export const LISTS = {
  schedule: {
    title: "Schedule", noun: "event", primary: "title",
    sub: (x) => [x.date, x.time && `${x.time}${x.end_time ? `–${x.end_time}` : ""}`, x.location].filter(Boolean).join(" · "),
    fields: [
      { key: "title", label: "Event name", required: true },
      { key: "date", label: "Day / date (e.g. Friday, July 10)" },
      { key: "time", label: "Start time" },
      { key: "end_time", label: "End time" },
      { key: "location", label: "Location" },
      { key: "description", label: "Details", type: "textarea" },
    ],
  },
  questions: {
    title: "Form questions", noun: "question", primary: "label",
    sub: (x) => [x.section, x.position === "household" ? "in Your household" : x.position === "after" ? "after activities" : "before activities", x.type, x.required && "required"].filter(Boolean).join(" · "),
    fields: [
      { key: "label", label: "Question", required: true },
      { key: "section", label: "Section heading (e.g. Getting around)" },
      { key: "position", label: "Where it shows on the form", type: "select", options: [["household", "In 'Your household'"], ["before", "Before activities"], ["after", "After activities"]], default: "before" },
      { key: "type", label: "Answer type", type: "select", options: [["text", "Short answer"], ["textarea", "Long answer"], ["number", "Number"], ["date", "Date"], ["select", "Pick one"], ["checkbox", "Pick several"], ["yesno", "Yes / No"]], default: "text" },
      { key: "options", label: "Choices (one per line) — for Pick one / Pick several", type: "lines" },
      { key: "required", label: "Required", type: "bool" },
    ],
  },
  activities: {
    title: "Activities", noun: "activity", primary: "name",
    sub: (x) => [Number(x.price_adult) || Number(x.price_keiki) ? `$${x.price_adult || 0} adult / $${x.price_keiki || 0} keiki` : "free", x.price_note, x.description].filter(Boolean).join(" · "),
    fields: [
      { key: "name", label: "Activity name", required: true },
      { key: "price_adult", label: "Price per adult ($, blank = free)" },
      { key: "price_keiki", label: "Price per keiki ($, blank = free)" },
      { key: "price_note", label: "Price note (e.g. ages 10 and up)" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "capacity", label: "Capacity (optional)" },
    ],
  },
  teams: {
    title: "Help-out teams", noun: "team", primary: "name",
    sub: (x) => [x.color, x.captain && `captain ${x.captain}`, x.description].filter(Boolean).join(" · "),
    fields: [
      { key: "name", label: "Team name", required: true },
      { key: "color", label: "Color" },
      { key: "captain", label: "Captain" },
      { key: "description", label: "Description", type: "textarea" },
    ],
  },
};
